<template>
  <div>
    <div v-for="(option, index) of options">
      <EditableInput
        v-model="options[index]"
        @input="$emit('input', options)"
        @remove="removeOption"
        :isLast="isLast"
      >
        <template slot-scope="props">
          <input
            class="form-control text-muted input-sm editable-input"
            type="text"
            v-model="props.model.ownValue"
          />
        </template>
      </EditableInput>
    </div>
    <div class="add-option" @click.prevent="addNewOption">Add option</div>
  </div>
</template>

<script>
import EditableInput from './EditableInput';

export default {
  name: 'multiple-and-exclusive-choice-component',
  components: {
    EditableInput,
  },
  props: {
    value: { type: Array, default: () => [] },
    type: { type: String, default: '' },
  },

  data() {
    return {
      options: [],
    };
  },
  methods: {
    generateId(id = 0) {
      const newId = id + 1;

      if (this.options.includes(`Option ${newId}`)) {
        return this.generateId(newId);
      }

      return newId;
    },
    addNewOption() {
      this.options.push(`Option ${this.generateId()}`);
      this.$emit('input', this.options);
    },
    removeOption(option) {
      this.options = this.options.filter(opt => opt !== option);
      this.$emit('input', this.options);
    },
  },
  computed: {
    isLast() {
      return this.options.length === 1;
    },
  },
  mounted() {
    if (!this.value.length) {
      this.addNewOption();
    } else {
      this.options = [...this.value];
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.add-option {
  border: 2px solid #868e96;
  width: 110px;
  padding: 3px 10px;
  background: #f4f5f7;
  margin: 10px 0 10px 0;
  cursor: pointer;
}

.input {
  margin: 10px 5px 0 0;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/modals/FieldAndQuery/components/MultipleAndExclusiveChoice.vue